import { render, staticRenderFns } from "./domain-journey-panel.vue?vue&type=template&id=9caf3b48&scoped=true"
import script from "./domain-journey-panel.ts?vue&type=script&lang=ts&external"
export * from "./domain-journey-panel.ts?vue&type=script&lang=ts&external"
import style0 from "./domain-journey-panel.scss?vue&type=style&index=0&id=9caf3b48&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9caf3b48",
  null
  
)

export default component.exports